/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Tokens } from '@jda/lui-common-component-library-mui5';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    fontSize: Tokens.spacing['$sp-4'],
  },
  rootTab: {
    background: 'transparent !important'
  },
  searchInputContainer: {
    marginBottom: Tokens.spacing['$sp-2']
  },
  loader: {
    textAlign: "center",
    alignItems: "center",
    padding: Tokens.spacing['$sp-3']
  },
  cardAlign: {
    minWidth: theme.spacing(116)
  },
  card: {
    height: 'auto'
  },
  cardBody: {
    height: 'auto',
    display: 'flex',
    flexDirection: 'row'
  },
  margin: {
  },
  loaderAlign: {
    marginLeft: theme.spacing(25),
  },
  viewPolicyText: {
    cursor: 'pointer',
    display: 'inline-block'
  },
  actionsSection: {
    display: 'flex',
    justifyContent: 'right',
    backgroundColor: theme.palette.background.paper,
  },
  dialogWrapper: {
    flexDirection: 'column'
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: "center",
    padding: '0 12px'
  },
  closeButton: {
    marginRight: '-11px'
  },
  dialogContent: {
    padding: Tokens.spacing['$sp-2'],
  },
  controlPanel: {
    alignItems: 'center',
    padding: theme.spacing(0.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  filterBlock: {
    display: 'flex',
    paddingTop: Tokens.spacing['$sp-1'],
    paddingBottom: Tokens.spacing['$sp-1'],
  },
  actionBlock: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  policyTypeDropdown: {
    maxWidth: 400
  },
  policyTypeOption: {
    paddingTop: Tokens.spacing['$sp-2-5'],
    paddingBottom: Tokens.spacing['$sp-2-5']
  },
  searchInput: {
    maxWidth: Tokens.spacing['$sp-70'],
    marginTop: Tokens.spacing['$sp-1-75'],
    right: Tokens.spacing['$sp-2'],
  },
  selectAllFilter: {
    width: Tokens.spacing['$sp-60'],
    marginLeft: Tokens.spacing['$sp-3'],
  },
  toolbarPanel: {
    padding: Tokens.spacing['$sp-3'],
  },
  fullscreen: {
    '& .MuiDialog-paper': {
      minWidth: '100vw !important',
      minHeight: '100vh !important',
      margin: 0,
    }
  }
}));
